import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@rocketlane/ui';
import React, { useCallback } from 'react';

export interface VersionHistoryTriggerProps {
  nodeId: number;
  nodeType: string;
  onVersionHistoryClick?: (nodeId: number, nodeType: string) => void;
}

export const VersionHistoryTrigger: React.FC<VersionHistoryTriggerProps> = ({
  nodeId,
  nodeType,
  onVersionHistoryClick,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onVersionHistoryClick?.(nodeId, nodeType);
    },
    [onVersionHistoryClick, nodeId, nodeType],
  );

  return (
    <Button
      type="button"
      variant="ghost"
      size="medium"
      leftIcon={<FontAwesomeIcon icon={faClockRotateLeft} />}
      className="version-history-trigger"
      onClick={handleClick}
      title="Open answer history"
    />
  );
};
